export const uberPromoPhoneNumber = '+18555608237';
export const uberPromoAbTestName = 'uber_ride_with_care_promo';
